import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function useUserSchema() {
  const { t } = useTranslation();

  return Yup.object().shape({
    firstName: Yup.string().required(t("label.isRequiredValidation", { field: t("label.firstName") })),
    lastName: Yup.string().required(t("label.isRequiredValidation", { field: t("label.lastName") })),
    email: Yup.string().required(t("label.isRequiredValidation", { field: t("label.email") })),
    role: Yup.string().required(t("label.isRequiredValidation", { field: t("label.role") })),
    enabled: Yup.boolean(),
  });
}
